<template>
  <div class="flex flex-col">
    <slot></slot>
  </div>
</template>

<script>
import { provide, computed } from "vue";

export default {
  props: {
    modelValue: Array,
  },
  setup(props, { emit }) {
    const selected = computed(() => props.modelValue || []);

    const updateValue = (value) => {
      const current = [...(props.modelValue || [])];
      const index = current.indexOf(value);
      if (index === -1) {
        current.push(value);
      } else {
        current.splice(index, 1);
      }
      emit("update:modelValue", current);
    };

    provide("checkboxGroup", { selected, updateValue });

    return { selected };
  },
};
</script>